/* tslint:disable */
/* eslint-disable */
/**
 * IRM.Web.Customer.API
 * 6d75acac-ec29-43a4-9fe0-2808f10c310c Development
 *
 * The version of the OpenAPI document: 2024.05.17.1151
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import { BrokenRule } from "./broken-rule";
// May contain unused imports in some cases
// @ts-ignore
import { DocumentLine } from "./document-line";

/**
 *
 * @export
 * @interface QuotationLineModelDocumentModel
 */
export interface QuotationLineModelDocumentModel {
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  CalculatedAmountDue?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  CalculatedAmountPretax?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  CalculatedPriceBeforePrepaidDiscount?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  CalculatedSumAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  CalculatedSumAmountPrepaidDiscount?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  CalculatedSumAmountPretax?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  CalculatedSumAmountValue?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  CalculatedSumQuantity?: number;
  /**
   *
   * @type {boolean}
   * @memberof QuotationLineModelDocumentModel
   */
  ContractAcceptanceShow?: boolean;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  AccrualAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  AccrualQuantity?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  ActualCarrierCode?: string | null;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  Amount?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  AmountDue?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  AmountPaid?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  ApprovalStatus?: QuotationLineModelDocumentModelApprovalStatusEnum;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  Approver1?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  Approver2?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  BillToAddress?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  BillToCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  BLComments?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  CardCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  CardName?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  CarrierCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  ClosingRemarks?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  Comments?: string | null;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  ContactPersonCode?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  ContractAmountCommitted?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  ContractAmountPrepaid?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  ContractAmountPrepaidInvoiced?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  ContractAmountPrepaidOrdered?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  ContractAmountPrepaidRemaining?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  ContractDate?: string;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  ContractTime?: string;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  ContractLineNumber?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  ContractNumber?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  ContractQuantityCommitted?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  ContractQuantityDelivered?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  ContractQuantityInvoiced?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  ContractQuantityOrdered?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  ContractQuantityOrderedOpen?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  ContractQuantityRemaining?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  ContractReferenceNumber?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  ContractStatus?: QuotationLineModelDocumentModelContractStatusEnum;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  ContractType?: QuotationLineModelDocumentModelContractTypeEnum;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  CreateDateTime?: string;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  CreateUser?: string | null;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  CreateUserSign?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  Currency?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  CustomsBrokerCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  DangerousGoods?: QuotationLineModelDocumentModelDangerousGoodsEnum;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  DeliveryDate?: string;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  DiscountAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  DiscountAmount1?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  DiscountAmount2?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  DiscountAmount3?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  DiscountPercent?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  DiscountPercent1?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  DiscountPercent2?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  DiscountPercent3?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  DocDate?: string;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  DocDueDate?: string;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  DocEntry?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  DocSent?: string | null;
  /**
   *
   * @type {Array<DocumentLine>}
   * @memberof QuotationLineModelDocumentModel
   */
  DocumentLines?: Array<DocumentLine> | null;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  DocumentNumber?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  DocumentStatus?: QuotationLineModelDocumentModelDocumentStatusEnum;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  DocumentType?: QuotationLineModelDocumentModelDocumentTypeEnum;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  DraftDocEntry?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  DriverName?: string | null;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  DuplicateReleaseNumber?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  EquipmentId?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  Exchange?: QuotationLineModelDocumentModelExchangeEnum;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  FormId?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  FreightAllowanceAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  FreightChargeAmount?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  FreightTermsCode?: string | null;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  FuelSurchargePercent?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  ImportExport?: QuotationLineModelDocumentModelImportExportEnum;
  /**
   *
   * @type {boolean}
   * @memberof QuotationLineModelDocumentModel
   */
  IsCanceled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof QuotationLineModelDocumentModel
   */
  IsDraft?: boolean;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  LoadScaleTicketComments?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  MasterBill?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  ModeOfTransportationCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  NumAtCard?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  ObjectType?: QuotationLineModelDocumentModelObjectTypeEnum;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  OpeningRemarks?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  PAPS?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  PaymentMethodCode?: string | null;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  PaymentTermsCode?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  Placards?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  PortOfEntryCode?: string | null;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  PostedPrice?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  PrebuyDate1?: string;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  PrebuyDate2?: string;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  PrebuyPercent1?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  PrebuyPercent2?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  PriceBeforePrepaidDiscount?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  Printed?: QuotationLineModelDocumentModelPrintedEnum;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  PrintLoadScaleTicket?: QuotationLineModelDocumentModelPrintLoadScaleTicketEnum;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  PrintProforma?: QuotationLineModelDocumentModelPrintProformaEnum;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  PrivateEquipment?: QuotationLineModelDocumentModelPrivateEquipmentEnum;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  ProjectCode?: string | null;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  ReferenceDocEntry?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  ReleaseNumber?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  RequiredDate?: string;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  Route?: string | null;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  SalespersonCode?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  SalesTermsCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  SealNumber?: string | null;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  SeriesCode?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  ShipDateEnd?: string;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  ShipDateStart?: string;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  ShipperName?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  ShipToAddress?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  ShipToCode?: string | null;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  StorageAmount?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  StorageDate?: string;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  SummaryType?: QuotationLineModelDocumentModelSummaryTypeEnum;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  SupplierReleaseNumber?: string | null;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  TaxAmount?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  TaxDate?: string;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  TimeIn?: string;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  TimeOut?: string;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  TradeNumber?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  Transfer?: QuotationLineModelDocumentModelTransferEnum;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  UpdateDateTime?: string;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  UpdateUser?: string | null;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  UpdateUserSign?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  AcceptanceStatus?: QuotationLineModelDocumentModelAcceptanceStatusEnum;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  ValidDate?: string;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  ValidTime?: string;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  ValidTimeZone?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  SearchItemShortName?: string | null;
  /**
   *
   * @type {number}
   * @memberof QuotationLineModelDocumentModel
   */
  SearchQuantity?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationLineModelDocumentModel
   */
  SearchWarehouseCode?: string | null;
  /**
   *
   * @type {Array<BrokenRule>}
   * @memberof QuotationLineModelDocumentModel
   */
  BrokenRules?: Array<BrokenRule> | null;
}

/**
 * @export
 * @enum {string}
 */
export enum QuotationLineModelDocumentModelApprovalStatusEnum {
  None = "None",
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected",
  Generated = "Generated",
  GeneratedByApprover = "GeneratedByApprover",
  Cancelled = "Cancelled",
  Without = "Without",
  TreasuryToUpdate = "TreasuryToUpdate",
}
/**
 * @export
 * @enum {string}
 */
export enum QuotationLineModelDocumentModelContractStatusEnum {
  None = "None",
  Open = "Open",
  Closed = "Closed",
  Pending = "Pending",
  Canceled = "Canceled",
  Offer = "Offer",
  Request = "Request",
}
/**
 * @export
 * @enum {string}
 */
export enum QuotationLineModelDocumentModelContractTypeEnum {
  None = "None",
  Prebuy = "Prebuy",
  PriceQuote = "PriceQuote",
  Regular = "Regular",
}
/**
 * @export
 * @enum {string}
 */
export enum QuotationLineModelDocumentModelDangerousGoodsEnum {
  None = "None",
  No = "No",
  Yes = "Yes",
}
/**
 * @export
 * @enum {string}
 */
export enum QuotationLineModelDocumentModelDocumentStatusEnum {
  None = "None",
  Open = "Open",
  Closed = "Closed",
  Paid = "Paid",
  Delivered = "Delivered",
  OpenPrinted = "OpenPrinted",
  Canceled = "Canceled",
  Unapproved = "Unapproved",
}
/**
 * @export
 * @enum {string}
 */
export enum QuotationLineModelDocumentModelDocumentTypeEnum {
  None = "None",
  Item = "Item",
  Service = "Service",
}
/**
 * @export
 * @enum {string}
 */
export enum QuotationLineModelDocumentModelExchangeEnum {
  None = "None",
  No = "No",
  Yes = "Yes",
}
/**
 * @export
 * @enum {string}
 */
export enum QuotationLineModelDocumentModelImportExportEnum {
  None = "None",
  No = "No",
  Yes = "Yes",
}
/**
 * @export
 * @enum {string}
 */
export enum QuotationLineModelDocumentModelObjectTypeEnum {
  None = "None",
  OBusinessPartners = "oBusinessPartners",
  OItems = "oItems",
  OInvoices = "oInvoices",
  OCreditNotes = "oCreditNotes",
  ODeliveryNotes = "oDeliveryNotes",
  OReturns = "oReturns",
  OOrders = "oOrders",
  OPurchaseInvoices = "oPurchaseInvoices",
  OPurchaseCreditNotes = "oPurchaseCreditNotes",
  OPurchaseDeliveryNotes = "oPurchaseDeliveryNotes",
  OPurchaseReturns = "oPurchaseReturns",
  OPurchaseOrders = "oPurchaseOrders",
  OQuotations = "oQuotations",
  OIncomingPayments = "oIncomingPayments",
  Deposit = "Deposit",
  OJournalEntries = "oJournalEntries",
  OVendorPayments = "oVendorPayments",
  OInventoryGenEntry = "oInventoryGenEntry",
  OInventoryGenExit = "oInventoryGenExit",
  OWarehouses = "oWarehouses",
  AtdtCorrectionInvoice = "atdtCorrectionInvoice",
  OProductionOrders = "oProductionOrders",
  ODownPayments = "oDownPayments",
  OPurchaseDownPayments = "oPurchaseDownPayments",
  InternalReconciliation = "InternalReconciliation",
  AtdtInventoryPosting = "atdtInventoryPosting",
  AtdtInventoryOpeningBalance = "atdtInventoryOpeningBalance",
  OPurchaseQuotations = "oPurchaseQuotations",
  OPurchaseQuotationGroups = "oPurchaseQuotationGroups",
  TrialBalanceFloQastReport = "TrialBalanceFloQastReport",
  TrialBalanceFloQast2Report = "TrialBalanceFloQast2Report",
  AtdtInventoryCounting = "atdtInventoryCounting",
  NotImplemented = "NotImplemented",
  CancelledReconcilliation = "CancelledReconcilliation",
  Bn = "BN",
  ClosingBalance = "ClosingBalance",
  OpeningBalance = "OpeningBalance",
}
/**
 * @export
 * @enum {string}
 */
export enum QuotationLineModelDocumentModelPrintedEnum {
  None = "None",
  No = "No",
  Yes = "Yes",
  Amended = "Amended",
}
/**
 * @export
 * @enum {string}
 */
export enum QuotationLineModelDocumentModelPrintLoadScaleTicketEnum {
  None = "None",
  No = "No",
  Yes = "Yes",
}
/**
 * @export
 * @enum {string}
 */
export enum QuotationLineModelDocumentModelPrintProformaEnum {
  None = "None",
  No = "No",
  Yes = "Yes",
}
/**
 * @export
 * @enum {string}
 */
export enum QuotationLineModelDocumentModelPrivateEquipmentEnum {
  None = "None",
  No = "No",
  Yes = "Yes",
}
/**
 * @export
 * @enum {string}
 */
export enum QuotationLineModelDocumentModelSummaryTypeEnum {
  None = "None",
  NoSummary = "NoSummary",
  ByItems = "ByItems",
  ByDocuments = "ByDocuments",
}
/**
 * @export
 * @enum {string}
 */
export enum QuotationLineModelDocumentModelTransferEnum {
  None = "None",
  No = "No",
  Yes = "Yes",
}
/**
 * @export
 * @enum {string}
 */
export enum QuotationLineModelDocumentModelAcceptanceStatusEnum {
  None = "None",
  NotRequired = "NotRequired",
  Required = "Required",
  PendingAcceptance = "PendingAcceptance",
  Accepted = "Accepted",
  Expired = "Expired",
  Canceled = "Canceled",
  AlreadyAccepted = "AlreadyAccepted",
}
